import React from 'react';
import './ListControls.css';

export type StatusOption = { label: string; value: string };
export type TypeOption = { label: string; value: string };

interface ListControlsProps {
  searchValue: string;
  onSearchChange: (value: string) => void;
  searchPlaceholder?: string;
  sticky?: boolean;

  statusValue?: string;
  onStatusChange?: (value: string) => void;
  statusOptions?: StatusOption[];

  typeValue?: string;
  onTypeChange?: (value: string) => void;
  typeOptions?: TypeOption[];
}

const ListControls: React.FC<ListControlsProps> = ({
  searchValue,
  onSearchChange,
  searchPlaceholder = 'Search...',
  sticky = false,
  statusValue,
  onStatusChange,
  statusOptions,
  typeValue,
  onTypeChange,
  typeOptions,
}) => {
  const showStatus = !!statusOptions && statusOptions.length > 0 && !!onStatusChange;
  const showType = !!typeOptions && typeOptions.length > 0 && !!onTypeChange;
  const fieldCount = 1 + Number(showStatus) + Number(showType);
  const layoutClass =
    fieldCount === 3 ? 'list-controls--three' : fieldCount === 2 ? 'list-controls--two' : 'list-controls--one';

  return (
    <div
      className={`list-controls ${layoutClass} ${sticky ? 'list-controls--sticky' : ''}`.trim()}
      data-tour="list-controls"
      role="region"
      aria-label="List filters"
    >
      <label className="list-controls__field">
        <span className="list-controls__label">Search</span>
        <input
          className="list-controls__input"
          type="text"
          value={searchValue}
          placeholder={searchPlaceholder}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </label>

      {showStatus && (
        <label className="list-controls__field">
          <span className="list-controls__label">Status</span>
          <select
            className="list-controls__select"
            value={statusValue ?? ''}
            onChange={(e) => onStatusChange(e.target.value)}
          >
            {statusOptions!.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </label>
      )}

      {showType && (
        <label className="list-controls__field">
          <span className="list-controls__label">Type</span>
          <select
            className="list-controls__select"
            value={typeValue ?? ''}
            onChange={(e) => onTypeChange(e.target.value)}
          >
            {typeOptions!.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </label>
      )}
    </div>
  );
};

export default ListControls;
